import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { ProjectList } from "../../components/project";
import { CREATE_PROJECT } from "../../constants";
import { useHasPermission } from "../../utils";

export const Projects = () => {
  const [totalCount, setTotalCount] = useState(0);

  const navigate = useNavigate();

  const hasCreateProject = useHasPermission(CREATE_PROJECT);

  const handleAddClick = () => {
    navigate("/projects/add");
  };

  // construct array of buttons based on permissions
  const buttons = hasCreateProject ? [{ buttonText: "Add Project", buttonIcon: Add, onClick: handleAddClick }] : [];
  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Projects"
            subtitle={`${totalCount} projects`}
            // button
            buttons={buttons}
          />
        </Box>

        {/* table section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <ProjectList showFilterButton totalCount={totalCount} setTotalCount={setTotalCount} />
        </Box>
      </PageLayout>
    </>
  );
};
